<template>
  <gj-popover
      v-model="visible"
      @close="close"
      trigger="manual"
      placement="bottom-end"
  >
    <template slot="reference">
      <div class="message-bar" style="cursor: pointer" :style="{marginRight: sumMsgNumber === 0 ? '15px' : '35px'}"
           @click="open">
        <gj-badge :hidden="sumMsgNumber === 0" :value="sumMsgNumber" :max="99">
          <i style="color: white" class="el-icon-bell"></i>
        </gj-badge>
      </div>
    </template>
    <template>
      <div style="width: 333px">
        <div style="width: 100%; display: flex; justify-content: space-between;padding: 0 30px;box-sizing: border-box;" class="message-bar">
          <div>
            <span @click="clickTitle('system')" class="message-title"
                  :class="{'message-title--border': active === 'system'}">
              系统消息 <span class="message-title-number" v-if="isMeaningful(msgNumber.system) && msgNumber.system > 0">{{msgNumber.system > 99 ? '99+' : (msgNumber.system + '')}}</span>
            </span>
          </div>
          <div>
            <span @click="clickTitle('account')" class="message-title"
                  :class="{'message-title--border': active === 'account'}">
              账户消息 <span class="message-title-number" v-if="isMeaningful(msgNumber.account) && msgNumber.account > 0">{{msgNumber.account > 99 ? '99+' : (msgNumber.account + '')}}</span>
            </span>
          </div>
          <div>
            <span @click="clickTitle('operation')" class="message-title"
                  :class="{'message-title--border': active === 'operation'}">
               运营消息 <span class="message-title-number" v-if="isMeaningful(msgNumber.operation) && msgNumber.operation > 0">{{msgNumber.operation > 99 ? '99+' : (msgNumber.operation + '')}}</span>
            </span>
          </div>
        </div>
        <div class="message-content" v-loading="loading" :class="{'empty-center': !data || data.length === 0}">
          <div @click="routerMsg('/message/message-center', {type: active, id: active === 'operation' ? item.msgIds : item.id})" v-for="(item, index) in data" :key="index"
               style="border-bottom: 1px solid #e5e5e5; cursor: pointer; padding-top: 8px"
               class="message-item">
            <div class="gj-mb8">
<!--              <span class="message-content-type">{{item.msgsBizType.desc}}</span>-->
              <gj-tag type="plain" size="mini" class="message-tag" color="#1F6EEF">{{(!item.msgsBizType ? item.warnTypeName : item.msgsBizType.desc) || '-'}}</gj-tag>
              <span class="message-content-date" style="float: right;">{{item.createTime}}</span>
            </div>

            <div class="message-content-content text-ellipsis-2"  v-html="item.title" v-if="active !== 'operation'"></div>
            <div class="message-content-content text-ellipsis-2"  v-html="item.pushTitle" v-else></div>
          </div>
          <template v-if="!data || data.length === 0">
            <div style="width: 150px; height: 140px;">
              <gj-empty v-if="!data || data.length === 0"></gj-empty>
            </div>
          </template>
        </div>
        <div class="message-footer">
          <gj-button @click="routerMsg('/message/message-setting')" type="text">消息设置</gj-button>
          <gj-button @click="routerMsg('/message/message-center', {type: active})" type="text" style="padding: 8px 0 0 0;float: right">查看全部</gj-button>
        </div>
      </div>
    </template>
  </gj-popover>
</template>

<script>
  import {sysUserMsg, userMsg} from "../../../../api/message";
  import {isMeaningful} from "../../../../utils/common";
  import {isMeaningfulMixin} from "../../../../minxins";
  import {USER_SET_MESSAGE} from "@/store/mutation-types";
  import {mapGetters} from "vuex";
  import {getOperationMessage} from "@/api/warning";
  import _ from 'lodash';

  export default {
    name: "message-popover",
    mixins: [isMeaningfulMixin],
    computed:{
      ...mapGetters(['msgNumber']),
      sumMsgNumber: {
        get: function () {
          return this.msgNumber.system + this.msgNumber.account + this.msgNumber.operation;
        },
        set: function () {
        }
      }
    },

    data() {
      return {
        loading: false,
        visible: false,
        active: 'system',
        data: []
      }
    },

    created() {
      setTimeout(() => {
        this.queryFunction();
      }, 500)
    },

    methods: {
      // 一次性获取系统、账号、运营
      queryFunction(){
        this.querySysMsgData();
        this.queryUserMsgData('account');
        this.queryOperationMessage();
      },

      // 打开弹窗
      open() {
        this.visible = true;
        this.queryFunction();
      },

     // 因为popover关闭时会触发两次close
     close:_.debounce(function (){
       this.visible = false;
       this.queryFunction();
     },300),

      // 点击tab进行切换
      clickTitle(flag) {
        this.active = flag;
        if (flag === 'system') {
          this.querySysMsgData();
        } else if (flag === 'account') {
          this.queryUserMsgData('account');
        } else {
          this.queryOperationMessage();
        }
      },

      // 获取系统消息
      querySysMsgData() {
        this.loading = true;
        sysUserMsg().then(res => {
          if (isMeaningful(res.data)) {
            this.$store.commit(USER_SET_MESSAGE, {type: 'system', value: res.data.msgNum});
            if (this.active === 'system') {
              this.data = res.data.msgResultS
            }
          }
        }).complete(() => this.loading = false)
      },

      // 获取账号消息
      queryUserMsgData(bizGroup) {
        this.loading = true;
        userMsg(bizGroup).then(res => {
          if (isMeaningful(res.data)) {
              this.$store.commit(USER_SET_MESSAGE, {type: 'account', value:  res.data.msgNum});
              if (this.active === 'account') {
                this.data = res.data.msgResultS
              }
          }
        }).complete(() => this.loading = false)
      },

      // 路由跳转
      routerMsg(path, query) {
        this.$router.push({path: path, query: query});
        this.visible = false;
      },

     // 获取运营列表信息
     async queryOperationMessage(){
       this.loading = true;
       const params = {
         model: {hasRead: false, pushPro: 1},
         current: 1,
         size: 6
       };

       try{
         const {data} = await getOperationMessage(params);
         this.$store.commit(USER_SET_MESSAGE, {type: 'operation', value: data.total});
         if (this.active === 'operation') {
           this.data = data.records;
         }
       }finally {
         this.loading=false;
       }
     },

      // 当点击消息弹窗中的任何元素
      grandChange(){
        if(this.visible){
          this.visible=false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .message-bar /deep/ .el-badge__content.is-fixed {
    position: absolute;
    top: 0;
    right: 3px;
    transform: translateY(-50%) translateX(100%);
    border: unset;
  }

  .message-title {
    display: inline-block;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #666;
  }

  .message-title--border {
    color: #1F6EEF;
    padding-bottom: 2px;
    border-bottom: 2px solid #1F6EEF;
  }

  .message-content {
    height: 244px;
    overflow-y: hidden;
  }

  .empty-center{
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .message-content:hover {
    overflow-y: overlay;
  }

  .message-item:hover {
    background: #f2f2f2;
  }

  /deep/.message-tag{
    background: #EEF3FE !important;
    border-radius: 2px !important;
    line-height: 16px !important;
    height: 18px !important;
  }

  .message-content-date {
    color: #999;
    margin-right: 10px;
    line-height: 18px;
  }

  .message-content-content {
    color: #666;
    margin: 0 10px 8px 0;
    line-height: 18px;
  }

  .message-footer {
    margin-top: 4px;
    /* border-top: 3px solid #f8f8f8; */
    /deep/ .el-button--small{
      padding-bottom: 0;
    }
  }
  .message-title-number{
    background: #EEEFF0;
    padding: 1px 4px;
    border-radius: 75px;
    font-size: 12px;
    color: #333333;
    font-weight: 600;
  }
</style>
